module.exports = __webpack_public_path__ + "media/images/emblems/CastelSanPietro-coat_of_arms-0981c93c734c7d06c1916fdd5ca4a020.svg";